module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-9a74fee87967166acca70cff38f3e511.webp";